/* Non-invasive XCloud diagnostic, activated only by ?ak_xcloud_diag=1.
   No filter values or URLs are modified; no navigation is intercepted.
   Trace is session-local, survives the proxy redirect, and can be copied
   from the browser console. */
(function () {
  'use strict';
  var key='albaki_bisac_xcloud_trace_v1';
  var marker='ak_xcloud_diag';
  var active=false;
  try {
    active=new URLSearchParams(location.search).get(marker)==='1' || sessionStorage.getItem(key+'_active')==='1';
    if (active) sessionStorage.setItem(key+'_active','1');
  } catch (_) { return; }
  if (!active || !document.querySelector('[data-albaki-catalog]')) return;
  function log(kind, info){
    try {
      var items=JSON.parse(sessionStorage.getItem(key)||'[]');
      if(!Array.isArray(items)) items=[];
      items.push({at:new Date().toISOString(),kind:kind,info:info||{},path:location.pathname,search:location.search});
      if(items.length>35)items=items.slice(-35);
      sessionStorage.setItem(key,JSON.stringify(items));
      console.debug('[Albaki XCloud diagnostic]',kind,info||{});
    } catch (_){}
  }
  function labelFor(el){
    if(!el) return '';
    var label=el.closest('label,[data-filter-value],button,a');
    var raw=label?label.getAttribute('data-filter-value')||label.textContent||'':el.value||'';
    return String(raw).trim().replace(/\s+/g,' ').slice(0,85);
  }
  function describe(el){
    var group=el.closest('[data-filter-name]');
    var link=el.closest('a[href]');
    var form=el.closest('form');
    return {tag:el.tagName,name:el.getAttribute('name')||'',type:el.getAttribute('type')||'',value:labelFor(el),facet:group&&group.getAttribute('data-filter-name')||'',href:link&&link.getAttribute('href')||'',action:form&&form.getAttribute('action')||''};
  }
  function capture(e){
    var el=e.target&&e.target.closest&&e.target.closest('#cloud_search_filters_sidebar *,#cloud_search_filters_root *,[data-albaki-sort-slot] *');
    if(el)log(e.type,describe(el));
  }
  // Observe XCloud's own transport without modifying responses or behavior.
  if(typeof window.fetch==='function') {
    var originalFetch=window.fetch;
    window.fetch=function(){
      try { var first=arguments[0];var href=first&&first.url?first.url:String(first);if(/a\/search|cloud_search|sections=|section_id=/i.test(href))log('fetch',{url:href.slice(0,350)}); }catch(_){}
      return originalFetch.apply(this,arguments);
    };
  }
  if(window.XMLHttpRequest&&XMLHttpRequest.prototype.open){
    var originalOpen=XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open=function(method,url){
      try{ if(/a\/search|cloud_search|sections=|section_id=/i.test(String(url)))log('xhr',{method:String(method),url:String(url).slice(0,350)}); }catch(_){}
      return originalOpen.apply(this,arguments);
    };
  }
  document.addEventListener('click',capture,true);
  document.addEventListener('change',capture,true);
  document.addEventListener('submit',capture,true);
  window.addEventListener('pagehide',function(){ log('pagehide',{url:location.href}); });
  window.addEventListener('popstate',function(){ log('popstate',{url:location.href}); });
  log('init',{hasGrid:!!document.getElementById('ProductGridContainer'),hasSidebar:!!document.getElementById('cloud_search_filters_sidebar'),hasCloudData:!!document.getElementById('cloudsearch-data')});
  console.info('[Albaki XCloud] After selecting a filter, copy the trace with: sessionStorage.getItem("'+key+'")');
})();
